import { render, staticRenderFns } from "./forgotpassword.vue?vue&type=template&id=6719ed86&scoped=true"
import script from "./forgotpassword.vue?vue&type=script&lang=js"
export * from "./forgotpassword.vue?vue&type=script&lang=js"
import style0 from "./forgotpassword.vue?vue&type=style&index=0&id=6719ed86&prod&scoped=true&lang=css"
import style1 from "./forgotpassword.vue?vue&type=style&index=1&id=6719ed86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6719ed86",
  null
  
)

export default component.exports